import React, { useState, useEffect } from 'react';
import CustomSelect from "components/Input/CustomSelect.js";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import CheckIcon from '@mui/icons-material/Check';
import { FormControlLabel, ListItem, FormControl } from "@mui/material";
import { filtersData } from "variables/lists/meters";
import { TextInput, FloatInput } from "components/Input/Index.js"
import DateInput from "components/Input/DateInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import { makeStyles } from "@mui/styles";

function LineFilter(props) {
    const { filter, handleFilterChange, removeFilter } = props;
    const searchStyle = makeStyles(advancedSearchStyle);
    const classes = searchStyle();

    const [column, setColumn] = useState(filter.column || "");
    const [comparator, setComparator] = useState(filter.comparator || "");
    const [data, setData] = useState(filter.data || "");

    const handleRemoveFilter = (event, id) => {
        removeFilter(id);
    }

    const handleFilterColumnChoice = (event, id) => {
        setColumn(event.target.value);
        setComparator("");
        setData("");
        filter.column = event.target.value;
        filter.datatype = filtersData.find((x) => x.id == event.target.value)?.datatype;
        filter.comparator = "";
        filter.data = "";
        filter.check = false;
        handleFilterChange();
    }

    const handleFilterComparatorChoice = (event, id) => {
        setComparator(event.target.value);
        setData("");
        filter.comparator = event.target.value;
        filter.data = "";
        filter.check = false;
        handleFilterChange();
    }

    const handleFilterDataChoice = (event, id) => {
        setData(event.target.value);
        filter.data = event.target.value;
        filter.check = false;
    }

    const handleFilterCheck = (event, id) => {

        filter.check = true;
        handleFilterChange();
    }

    return (
        <ListItem style={{ justifyContent: "flex-end", marginTop: "-15px" }}>
            <GridContainer style={{ width: '50%' }}>
                <GridItem xs={6} md={4} lg={4} className={classes.compactGridItem}>
                    <FormControl fullWidth>
                        <CustomSelect
                            //marginTop="0"
                            style={{ marginTop: "0" }}
                            inputTitle={"Colonne"}
                            selectValue={column}
                            handleSelectValueChange={(e) => handleFilterColumnChoice(e, filter.id)}
                            data={filtersData}
                        />
                    </FormControl>
                </GridItem>
                <GridItem xs={6} md={3} lg={3} className={classes.compactGridItem}>
                    <FormControl fullWidth>
                        <CustomSelect
                            //marginTop="0"
                            disabled={!column}
                            style={{ marginTop: "0" }}
                            inputTitle={"Comparateur"}
                            selectValue={comparator}
                            handleSelectValueChange={(e) => handleFilterComparatorChoice(e, filter.id)}
                            data={filtersData.find((x) => x.id == column)?.comparator || []}
                        />
                    </FormControl>
                </GridItem>
                <GridItem xs={6} md={4} lg={4} className={classes.compactGridItem}>
                    <FormControl fullWidth>
                        {
                            comparator &&
                                filtersData.find((x) => x.id == column)?.datatype === 'select' ?
                                <FormControl>
                                    <CustomSelect
                                        //marginTop="0"
                                        inputTitle={"Valeur"}
                                        selectValue={data}
                                        handleSelectValueChange={(e) => handleFilterDataChoice(e, filter.id)}
                                        data={filtersData.find((x) => x.id == column)?.data || []}
                                    />
                                </FormControl> :
                                filtersData.find((x) => x.id == column)?.datatype === 'text' ?
                                    <FormControl>
                                        <TextInput
                                            inputTitle={"Valeur"}
                                            textInput={data}
                                            handleTextInputChange={(e) => handleFilterDataChoice(e, filter.id)}
                                        />
                                    </FormControl> :
                                    filtersData.find((x) => x.id == column)?.datatype === 'number' ?
                                        <FormControl>
                                            <FloatInput
                                                inputTitle={"Valeur"}
                                                floatInput={data}
                                                handleFloatInputChange={(e) => handleFilterDataChoice(e, filter.id)}
                                            />
                                        </FormControl> :
                                        filtersData.find((x) => x.id == column)?.datatype === 'listcount' ?
                                            <FormControl>
                                                <FloatInput
                                                    inputTitle={"Valeur"}
                                                    floatInput={data}
                                                    handleFloatInputChange={(e) => handleFilterDataChoice(e, filter.id)}
                                                />
                                            </FormControl> :
                                            filtersData.find((x) => x.id == column)?.datatype === 'date' ?
                                                <FormControl>
                                                    <DateInput
                                                        inputTitle={"Valeur"}
                                                        dateInput={data}
                                                        handleDateInputChange={(e) => handleFilterDataChoice(e, filter.id)}
                                                    />
                                                </FormControl> :
                                                <TextInput
                                                    inputTitle={"Valeur"}
                                                    disabled
                                                />
                        }
                    </FormControl>
                </GridItem>
                <FormControlLabel
                    style={{ marginLeft: "0px" }}
                    className={classes.formControlLabel}
                    value="remove"
                    control={
                        (!filter.data || filter.check) ?
                            <Button
                                style={{ paddingTop: "22px" }}
                                type="button"
                                round color="transparent" justIcon
                                //size={"lg"}
                                onClick={(e) => handleRemoveFilter(e, filter.id)}
                            >
                                <RemoveCircleOutline> </RemoveCircleOutline>
                            </Button> :
                            <Button
                                style={{ paddingTop: "22px" }}
                                type="button"
                                round color="transparent" justIcon
                                //size={"lg"}
                                onClick={(e) => handleFilterCheck(e, filter.id)}
                            >
                                <CheckIcon> </CheckIcon>
                            </Button>
                    }
                    labelPlacement="start"
                    label={""}
                />
            </GridContainer>
        </ListItem>
    );
}

export default LineFilter;